/* ============================================================
   Lexus Tools Theme — Global JavaScript
   lt-theme.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Scroll Progress Bar ─────────────────────────────── */
  function initScrollProgress() {
    var bar = document.getElementById('ltScrollProgress');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      var scrolled = window.scrollY;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (total > 0 ? (scrolled / total) * 100 : 0) + '%';
    }, { passive: true });
  }

  /* ── Back to Top ─────────────────────────────────────── */
  function initBackTop() {
    var btn = document.getElementById('ltBackTop');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 400);
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── Toast Notifications ─────────────────────────────── */
  window.ltShowToast = function (message, duration) {
    duration = duration || 2800;
    var container = document.getElementById('ltToastContainer');
    if (!container) return;
    var toast = document.createElement('div');
    toast.className = 'lt-toast';
    toast.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' + message;
    container.appendChild(toast);
    setTimeout(function () {
      toast.classList.add('is-removing');
      setTimeout(function () { toast.remove(); }, 300);
    }, duration);
  };

  /* ── Cart Badge Update ───────────────────────────────── */
  function updateCartBadge(count) {
    var badge = document.getElementById('ltCartBadge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }

  /* ── Header cart badge: live-refresh on ANY add-to-cart ──
     (all ATC flows dispatch cart:updated or cart:refresh) */
  function ltRefreshCartBadge() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartBadge(c.item_count); })
      .catch(function () {});
  }
  document.addEventListener('cart:updated', ltRefreshCartBadge);
  document.addEventListener('cart:refresh', ltRefreshCartBadge);

  /* ── Add to Cart (AJAX) ──────────────────────────────── */
  window.ltAddToCart = function (variantId, qty, btn) {
    if (!variantId) return;
    qty = qty || 1;
    if (btn) {
      btn.disabled = true;
      btn.style.opacity = '0.7';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        // Refresh cart count
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartBadge(cart.item_count); });
        ltShowToast('Added to cart!');
      })
      .catch(function () { ltShowToast('Could not add to cart. Try again.'); })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.style.opacity = '';
        }
      });
  };

  /* ── Quick View Modal ────────────────────────────────── */
  window.ltOpenQuickView = function (productUrl) {
    var overlay = document.getElementById('ltQuickViewOverlay');
    var gallery = document.getElementById('ltQvImg');
    var name    = document.getElementById('ltQvName');
    var cat     = document.getElementById('ltQvCat');
    var price   = document.getElementById('ltQvPrice');
    var oldPrice= document.getElementById('ltQvOldPrice');
    var save    = document.getElementById('ltQvSave');
    var desc    = document.getElementById('ltQvDesc');
    var variants= document.getElementById('ltQvVariants');
    if (!overlay) return;

    // Clear state
    if (gallery) gallery.src = '';
    if (name) name.textContent = 'Loading…';
    if (desc) desc.textContent = '';
    if (variants) variants.innerHTML = '';
    document.getElementById('ltQvQty') && (document.getElementById('ltQvQty').textContent = '1');

    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    fetch(productUrl + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (gallery && p.featured_image) gallery.src = p.featured_image;
        if (name) name.textContent = p.title;
        if (cat) cat.textContent = p.type || '';
        var firstVar = p.variants && p.variants[0];
        if (firstVar) {
          if (price) price.textContent = '₹' + (firstVar.price / 100).toLocaleString('en-IN');
          if (firstVar.compare_at_price > firstVar.price) {
            if (oldPrice) { oldPrice.textContent = '₹' + (firstVar.compare_at_price / 100).toLocaleString('en-IN'); oldPrice.style.display = ''; }
            var pct = Math.round((1 - firstVar.price / firstVar.compare_at_price) * 100);
            if (save) { save.textContent = 'Save ' + pct + '%'; save.style.display = ''; }
          } else {
            if (oldPrice) oldPrice.style.display = 'none';
            if (save) save.style.display = 'none';
          }
        }
        if (desc) desc.textContent = p.description ? p.description.replace(/<[^>]*>/g, '').substring(0, 200) + '…' : '';
        // Variants
        if (variants && p.variants && p.variants.length > 1) {
          p.variants.forEach(function (v, i) {
            var btn = document.createElement('button');
            btn.className = 'lt-variant-btn' + (i === 0 ? ' is-active' : '');
            btn.textContent = v.title;
            btn.dataset.variantId = v.id;
            btn.addEventListener('click', function () {
              variants.querySelectorAll('.lt-variant-btn').forEach(function (b) { b.classList.remove('is-active'); });
              this.classList.add('is-active');
              if (price) price.textContent = '₹' + (v.price / 100).toLocaleString('en-IN');
            });
            variants.appendChild(btn);
          });
        }
        // Add to cart button
        var atcBtn = document.getElementById('ltQvAddBtn');
        if (atcBtn && firstVar) {
          atcBtn.dataset.variantId = firstVar.id;
          atcBtn.onclick = function () {
            var activeVar = variants && variants.querySelector('.lt-variant-btn.is-active');
            var vid = activeVar ? activeVar.dataset.variantId : firstVar.id;
            var qty = parseInt(document.getElementById('ltQvQty') ? document.getElementById('ltQvQty').textContent : 1);
            ltAddToCart(vid, qty, this);
          };
        }
        // View full product link
        var viewBtn = document.getElementById('ltQvViewBtn');
        if (viewBtn) viewBtn.href = p.url;
      })
      .catch(function () { if (name) name.textContent = 'Could not load product.'; });
  };

  window.ltCloseQuickView = function () {
    var overlay = document.getElementById('ltQuickViewOverlay');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  /* ── Qty Control ─────────────────────────────────────── */
  window.ltChangeQty = function (delta) {
    var el = document.getElementById('ltQvQty');
    if (!el) return;
    var current = parseInt(el.textContent) || 1;
    el.textContent = Math.max(1, current + delta);
  };

  /* ── Welcome Popup ───────────────────────────────────── */
  function initWelcomePopup() {
    var overlay = document.getElementById('ltWelcomeOverlay');
    if (!overlay) return;
    if (localStorage.getItem('lt-welcome-shown')) return;
    var delay = parseInt(overlay.dataset.delay) || 3000;
    setTimeout(function () {
      overlay.classList.add('is-open');
    }, delay);
  }

  window.ltCloseWelcome = function () {
    var overlay = document.getElementById('ltWelcomeOverlay');
    if (overlay) overlay.classList.remove('is-open');
    localStorage.setItem('lt-welcome-shown', '1');
  };

  window.ltClaimDiscount = function () {
    var email = document.getElementById('ltWEmail');
    if (!email || !email.value.includes('@')) {
      ltShowToast('Please enter a valid email.', 2500);
      return;
    }
    var form = document.getElementById('ltWForm');
    var coupon = document.getElementById('ltWCoupon');
    if (form) form.style.display = 'none';
    if (coupon) coupon.style.display = 'block';
    localStorage.setItem('lt-welcome-shown', '1');
  };

  window.ltCopyCoupon = function () {
    var code = document.getElementById('ltWCouponCode');
    if (code && navigator.clipboard) {
      navigator.clipboard.writeText(code.textContent.trim())
        .then(function () { ltShowToast('Coupon code copied!'); })
        .catch(function () {});
    }
  };

  /* ── Countdown Timer ─────────────────────────────────── */
  window.ltInitCountdown = function (targetTimestamp) {
    var hEl = document.getElementById('ltCountHrs');
    var mEl = document.getElementById('ltCountMin');
    var sEl = document.getElementById('ltCountSec');
    if (!hEl || !mEl || !sEl) return;

    function tick() {
      var now = Math.floor(Date.now() / 1000);
      var diff = targetTimestamp - now;
      if (diff <= 0) { diff = 0; }
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      hEl.textContent = String(h).padStart(2, '0');
      mEl.textContent = String(m).padStart(2, '0');
      sEl.textContent = String(s).padStart(2, '0');
    }

    tick();
    setInterval(tick, 1000);
  };

  /* ── FAQ Accordion ───────────────────────────────────── */
  function initFaq() {
    document.querySelectorAll('.lt-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.closest('.lt-faq__item');
        var isOpen = item.classList.contains('is-open');
        // Close all
        document.querySelectorAll('.lt-faq__item.is-open').forEach(function (el) { el.classList.remove('is-open'); });
        // Open clicked if it was closed
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ── Product Tabs ────────────────────────────────────── */
  window.ltSwitchTab = function (btn, tabId) {
    var section = btn.closest('.lt-featured-products');
    if (!section) return;
    section.querySelectorAll('.lt-tab-btn').forEach(function (b) { b.classList.remove('is-active'); });
    section.querySelectorAll('.lt-tab-panel').forEach(function (p) { p.classList.remove('is-active'); });
    btn.classList.add('is-active');
    var panel = section.querySelector('#' + tabId);
    if (panel) panel.classList.add('is-active');
  };

  /* ── Scroll Fade-in ──────────────────────────────────── */
  function initFadeIn() {
    var els = document.querySelectorAll('.lt-fade');
    if (!els.length) return;
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function (el) { obs.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ── Modal click-outside close ───────────────────────── */
  function initModalClose() {
    document.addEventListener('click', function (e) {
      if (e.target.id === 'ltQuickViewOverlay') ltCloseQuickView();
      if (e.target.id === 'ltWelcomeOverlay') ltCloseWelcome();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        ltCloseQuickView();
        ltCloseWelcome();
      }
    });
  }

  /* ── Purchase Toast (social proof) ──────────────────────
     Fires on product pages. Rotates fake-but-plausible recent
     purchases every N seconds. Honours window.ltPurchaseToastConfig
     if defined (let merchants customize from a snippet). */
  function initPurchaseToast () {
    /* Only show on product pages — detect via the main-product section marker */
    var isProductPage = !!document.querySelector('[id^="lt-mp-"] .lt-mp__wrap')
      || document.body.classList.contains('template-product')
      || (window.Shopify && Shopify.template === 'product');
    if (!isProductPage) return;
    if (window.ltPurchaseToastDisabled) return;

    var cfg = window.ltPurchaseToastConfig || {};
    var buyers = cfg.buyers || [
      { name: 'Rajesh',    city: 'Mumbai',    ago: '2 minutes' },
      { name: 'Priya',     city: 'Delhi',     ago: '7 minutes' },
      { name: 'Anand',     city: 'Bangalore', ago: '12 minutes' },
      { name: 'Sneha',     city: 'Pune',      ago: '18 minutes' },
      { name: 'Vikram',    city: 'Chennai',   ago: '24 minutes' },
      { name: 'Neha',      city: 'Hyderabad', ago: '31 minutes' },
      { name: 'Arjun',     city: 'Jaipur',    ago: '38 minutes' },
      { name: 'Kavya',     city: 'Kolkata',   ago: '45 minutes' },
      { name: 'Rohit',     city: 'Ahmedabad', ago: '52 minutes' },
      { name: 'Meera',     city: 'Lucknow',   ago: '1 hour' }
    ];
    var interval = cfg.intervalMs || 12000;  // 12s between toasts
    var displayMs = cfg.displayMs || 5500;   // 5.5s visible
    var firstDelay = cfg.firstDelayMs || 6000; // 6s after page load
    var productName = (document.querySelector('.lt-mp__title') || {}).textContent || 'this product';

    // Inject CSS once
    if (!document.getElementById('lt-ptoast-styles')) {
      var style = document.createElement('style');
      style.id = 'lt-ptoast-styles';
      style.textContent = [
        '.lt-ptoast{position:fixed;bottom:100px;left:24px;background:#fff;border-radius:10px;',
        'box-shadow:0 12px 40px rgba(0,0,0,0.18);padding:14px 18px;display:flex;align-items:center;gap:12px;',
        'max-width:330px;z-index:350;border-left:4px solid #16A34A;',
        'opacity:0;transform:translateX(-120%);transition:opacity 0.35s ease,transform 0.45s cubic-bezier(0.16,1,0.3,1);',
        'font-family:"Inter",system-ui,sans-serif;}',
        '.lt-ptoast.visible{opacity:1;transform:translateX(0);}',
        '.lt-ptoast__avatar{width:38px;height:38px;border-radius:9999px;background:#EEEEF8;color:#3D3D99;',
        'display:flex;align-items:center;justify-content:center;font-weight:700;flex-shrink:0;',
        'font-family:"Inter",system-ui,sans-serif;font-style:italic;font-size:17px;}',
        '.lt-ptoast__text{font-size:13px;line-height:1.4;color:#1A1A2E;}',
        '.lt-ptoast__text strong{font-weight:700;}',
        '.lt-ptoast__meta{font-size:11px;color:#6B6B8A;margin-top:2px;}',
        '.lt-ptoast__close{position:absolute;top:6px;right:6px;width:20px;height:20px;border:0;',
        'background:transparent;cursor:pointer;color:#6B6B8A;font-size:16px;line-height:1;padding:0;}',
        '.lt-ptoast__close:hover{color:#1A1A2E;}',
        '@media (max-width:767px){.lt-ptoast{left:12px;right:12px;bottom:96px;max-width:none;}}'
      ].join('');
      document.head.appendChild(style);
    }

    var el = document.createElement('div');
    el.className = 'lt-ptoast';
    el.setAttribute('role', 'status');
    el.innerHTML = '<div class="lt-ptoast__avatar" data-init></div>'
      + '<div><div class="lt-ptoast__text" data-text></div><div class="lt-ptoast__meta" data-meta></div></div>'
      + '<button type="button" class="lt-ptoast__close" aria-label="Dismiss">×</button>';
    document.body.appendChild(el);

    var dismissed = false;
    el.querySelector('.lt-ptoast__close').addEventListener('click', function () {
      dismissed = true;
      hide();
    });

    var idx = Math.floor(Math.random() * buyers.length);
    var hideTimer;

    function show () {
      if (dismissed) return;
      var b = buyers[idx];
      idx = (idx + 1) % buyers.length;
      el.querySelector('[data-init]').textContent = b.name.charAt(0).toUpperCase();
      el.querySelector('[data-text]').innerHTML = '<strong>' + b.name + '</strong> from ' + b.city + ' just bought this';
      el.querySelector('[data-meta]').innerHTML = '🕐 ' + b.ago + ' ago · Verified buyer';
      requestAnimationFrame(function () { el.classList.add('visible'); });
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, displayMs);
    }
    function hide () {
      el.classList.remove('visible');
    }

    setTimeout(function () {
      show();
      setInterval(function () { if (!dismissed) show(); }, interval);
    }, firstDelay);
  }

  /* ── Quick View Modal ───────────────────────────────────
     Opens a lightweight preview of any product — fetches JSON
     from /products/{handle}.js. Renders image, title, price,
     short description, variant picker, qty, and ATC. */
  function ensureQuickViewDom () {
    if (document.getElementById('lt-qv-overlay')) return;
    var style = document.createElement('style');
    style.textContent = [
      '.lt-qv{position:fixed;inset:0;z-index:700;background:rgba(10,10,20,0.55);backdrop-filter:blur(6px);',
      'display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;pointer-events:none;',
      'transition:opacity 0.25s ease;font-family:"Inter",system-ui,sans-serif;}',
      '.lt-qv.open{opacity:1;pointer-events:all;}',
      '.lt-qv__dialog{background:#fff;border-radius:14px;width:100%;max-width:880px;max-height:90dvh;',
      'overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.22);display:grid;grid-template-columns:1fr 1fr;',
      'transform:translateY(20px) scale(0.97);transition:transform 0.35s cubic-bezier(0.16,1,0.3,1);}',
      '.lt-qv.open .lt-qv__dialog{transform:translateY(0) scale(1);}',
      '.lt-qv__media{background:#F4F4FA;min-height:360px;position:relative;}',
      '.lt-qv__media img{width:100%;height:100%;object-fit:cover;display:block;}',
      '.lt-qv__body{padding:28px;overflow-y:auto;display:flex;flex-direction:column;gap:16px;}',
      '.lt-qv__close{position:absolute;top:12px;right:12px;width:36px;height:36px;border-radius:9999px;',
      'background:rgba(255,255,255,0.95);border:0;cursor:pointer;display:flex;align-items:center;justify-content:center;',
      'color:#1A1A2E;box-shadow:0 2px 10px rgba(0,0,0,0.12);z-index:2;}',
      '.lt-qv__close:hover{background:#3D3D99;color:#fff;}',
      '.lt-qv__title{font-family:"Inter",system-ui,sans-serif;font-size:26px;color:#1A1A2E;line-height:1.2;}',
      '.lt-qv__price{font-family:"Inter",system-ui,sans-serif;font-weight:700;font-size:28px;color:#3D3D99;}',
      '.lt-qv__compare{font-size:16px;color:#6B6B8A;text-decoration:line-through;margin-left:10px;}',
      '.lt-qv__desc{font-size:14px;line-height:1.7;color:#1A1A2E;max-height:120px;overflow-y:auto;}',
      '.lt-qv__variants{display:flex;flex-direction:column;gap:10px;}',
      '.lt-qv__vlabel{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#6B6B8A;}',
      '.lt-qv__vselect{padding:10px 14px;border:1.5px solid #E8E8F2;border-radius:8px;font-size:14px;',
      'font-family:inherit;color:#1A1A2E;background:#fff;outline:none;cursor:pointer;}',
      '.lt-qv__vselect:focus{border-color:#3D3D99;}',
      '.lt-qv__row{display:flex;gap:10px;align-items:center;margin-top:auto;}',
      '.lt-qv__qty{display:flex;align-items:center;border:1.5px solid #E8E8F2;border-radius:8px;height:48px;}',
      '.lt-qv__qty button{width:40px;height:100%;border:0;background:transparent;font-size:20px;color:#6B6B8A;cursor:pointer;}',
      '.lt-qv__qty button:hover{background:#F4F4FA;color:#3D3D99;}',
      '.lt-qv__qty span{width:40px;text-align:center;font-weight:700;border-left:1px solid #E8E8F2;border-right:1px solid #E8E8F2;}',
      '.lt-qv__atc{flex:1;height:48px;background:#3D3D99;color:#fff;border:0;border-radius:8px;font-size:14px;',
      'font-weight:700;cursor:pointer;box-shadow:0 4px 14px rgba(61,61,153,0.28);transition:all 180ms ease;font-family:inherit;}',
      '.lt-qv__atc:hover{background:#2A2A6E;transform:translateY(-1px);}',
      '.lt-qv__atc:disabled{opacity:0.6;cursor:not-allowed;}',
      '.lt-qv__viewfull{font-size:13px;font-weight:700;color:#3D3D99;text-decoration:none;}',
      '.lt-qv__viewfull:hover{text-decoration:underline;}',
      '.lt-qv__loading{padding:40px;text-align:center;color:#6B6B8A;}',
      '@media (max-width:767px){.lt-qv__dialog{grid-template-columns:1fr;max-height:94dvh;}',
      '.lt-qv__media{min-height:220px;aspect-ratio:1/1;}.lt-qv__body{padding:20px;}}'
    ].join('');
    document.head.appendChild(style);

    var overlay = document.createElement('div');
    overlay.className = 'lt-qv';
    overlay.id = 'lt-qv-overlay';
    overlay.innerHTML = '<div class="lt-qv__dialog">'
      + '<div class="lt-qv__media" id="lt-qv-media">'
      + '<button type="button" class="lt-qv__close" id="lt-qv-close" aria-label="Close">'
      + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      + '</button>'
      + '</div>'
      + '<div class="lt-qv__body" id="lt-qv-body"><div class="lt-qv__loading">Loading…</div></div>'
      + '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) ltCloseQuickView();
    });
    document.getElementById('lt-qv-close').addEventListener('click', ltCloseQuickView);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) ltCloseQuickView();
    });
  }

  var qvCurrentProduct = null;
  var qvSelectedVariant = null;
  var qvQty = 1;

  window.ltOpenQuickView = function (productUrl) {
    ensureQuickViewDom();
    var overlay = document.getElementById('lt-qv-overlay');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    var body = document.getElementById('lt-qv-body');
    var media = document.getElementById('lt-qv-media');
    body.innerHTML = '<div class="lt-qv__loading">Loading…</div>';
    /* Keep close button, reset inner media image */
    var close = media.querySelector('.lt-qv__close');
    media.innerHTML = '';
    if (close) media.appendChild(close);

    var handle = productUrl.split('/products/')[1];
    if (!handle) { body.innerHTML = '<p style="padding:20px;">Product URL invalid.</p>'; return; }
    handle = handle.split('?')[0].split('#')[0];

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        qvCurrentProduct = p;
        qvQty = 1;
        qvSelectedVariant = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        renderQuickView(p);
      })
      .catch(function () {
        body.innerHTML = '<p style="padding:20px;color:#CC2222;">Could not load product.</p>';
      });
  };

  window.ltCloseQuickView = function () {
    var overlay = document.getElementById('lt-qv-overlay');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  };

  function fmtMoney (cents) {
    try {
      var fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'INR', minimumFractionDigits: 0 });
      return fmt.format(cents / 100);
    } catch (e) { return '₹' + (cents / 100).toFixed(0); }
  }

  function renderQuickView (p) {
    var media = document.getElementById('lt-qv-media');
    var body  = document.getElementById('lt-qv-body');
    var close = media.querySelector('.lt-qv__close');
    media.innerHTML = '';
    if (close) media.appendChild(close);
    var img = document.createElement('img');
    img.src = (p.featured_image || (p.images && p.images[0]) || '');
    img.alt = p.title;
    media.appendChild(img);

    var compareHtml = '';
    if (qvSelectedVariant.compare_at_price && qvSelectedVariant.compare_at_price > qvSelectedVariant.price) {
      compareHtml = '<span class="lt-qv__compare" id="lt-qv-compare">' + fmtMoney(qvSelectedVariant.compare_at_price) + '</span>';
    }

    var descExcerpt = (p.description || '').replace(/<[^>]+>/g, '').slice(0, 240);
    if (descExcerpt.length === 240) descExcerpt += '…';

    var variantsHtml = '';
    if (p.variants.length > 1 && p.options.length) {
      variantsHtml = '<div class="lt-qv__variants">';
      p.options.forEach(function (optName, i) {
        var values = [];
        p.variants.forEach(function (v) {
          var val = v.options[i];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        variantsHtml += '<div><div class="lt-qv__vlabel">' + optName + '</div>';
        variantsHtml += '<select class="lt-qv__vselect" data-opt-idx="' + i + '" onchange="window.ltQvChangeOption(this)">';
        values.forEach(function (val) {
          var sel = qvSelectedVariant.options[i] === val ? ' selected' : '';
          variantsHtml += '<option value="' + val.replace(/"/g, '&quot;') + '"' + sel + '>' + val + '</option>';
        });
        variantsHtml += '</select></div>';
      });
      variantsHtml += '</div>';
    }

    body.innerHTML = ''
      + '<h2 class="lt-qv__title">' + p.title + '</h2>'
      + '<div><span class="lt-qv__price" id="lt-qv-price">' + fmtMoney(qvSelectedVariant.price) + '</span>' + compareHtml + '</div>'
      + (descExcerpt ? '<div class="lt-qv__desc">' + descExcerpt + '</div>' : '')
      + variantsHtml
      + '<div class="lt-qv__row">'
      +   '<div class="lt-qv__qty">'
      +     '<button type="button" onclick="window.ltQvChangeQty(-1)">−</button>'
      +     '<span id="lt-qv-qtynum">1</span>'
      +     '<button type="button" onclick="window.ltQvChangeQty(1)">+</button>'
      +   '</div>'
      +   '<button type="button" class="lt-qv__atc" id="lt-qv-atc" onclick="window.ltQvAtc()">Add to Cart</button>'
      + '</div>'
      + '<a class="lt-qv__viewfull" href="' + p.url + '">View full details →</a>';
  }

  window.ltQvChangeQty = function (d) {
    qvQty = Math.max(1, qvQty + d);
    var el = document.getElementById('lt-qv-qtynum');
    if (el) el.textContent = qvQty;
  };

  window.ltQvChangeOption = function (sel) {
    if (!qvCurrentProduct) return;
    var idx = parseInt(sel.dataset.optIdx, 10);
    var val = sel.value;
    /* Build the full target option array from current selects */
    var selects = document.querySelectorAll('#lt-qv-body .lt-qv__vselect');
    var target = qvCurrentProduct.options.map(function (_, i) {
      var s = Array.prototype.find.call(selects, function (x) { return parseInt(x.dataset.optIdx, 10) === i; });
      return s ? s.value : qvSelectedVariant.options[i];
    });
    target[idx] = val;
    var match = qvCurrentProduct.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === target[i]; });
    });
    if (!match) return;
    qvSelectedVariant = match;
    document.getElementById('lt-qv-price').textContent = fmtMoney(match.price);
    var compareEl = document.getElementById('lt-qv-compare');
    if (compareEl) {
      if (match.compare_at_price > match.price) {
        compareEl.textContent = fmtMoney(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    var atc = document.getElementById('lt-qv-atc');
    if (atc) {
      atc.disabled = !match.available;
      atc.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }
    /* Swap image if variant has one */
    if (match.featured_image) {
      var mediaImg = document.querySelector('#lt-qv-media img');
      if (mediaImg) mediaImg.src = match.featured_image.src;
    }
  };

  window.ltQvAtc = function () {
    if (!qvSelectedVariant) return;
    var btn = document.getElementById('lt-qv-atc');
    if (!btn || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: qvSelectedVariant.id, quantity: qvQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          window.ltShowToast && ltShowToast(data.description || 'Could not add.');
        } else {
          window.ltShowToast && ltShowToast('✓ Added to cart');
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var b = document.querySelector('.lt-cart-count,[data-cart-count]');
            if (b) b.textContent = c.item_count;
          });
          ltCloseQuickView();
        }
      })
      .catch(function () { window.ltShowToast && ltShowToast('Could not add. Try again.'); })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  };

  /* ── Init on DOM ready ───────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initScrollProgress();
    initBackTop();
    initFadeIn();
    initFaq();
    initModalClose();
    initWelcomePopup();
    initPurchaseToast();
  });

})();
